import { motion } from 'motion/react'
import ActionButton from 'src/components/ActionButton'
import BlockTitle from 'src/components/BlockTitle'
import Illustration from 'src/components/Illustration'
import RichText from 'src/components/RichText'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const Grid = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    display: grid;
    gap: ${pxToRem(16)};
    grid-template-columns: repeat(3, 1fr);
    align-items: stretch;
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const _Illustration = styled(motion.create(Illustration))`
  @media ${mq(sizes.desktop)} {
    &:nth-child(5n + 1),
    &:nth-child(5n + 4),
    &:nth-child(5n + 5) {
      grid-column-end: span 1;
      aspect-ratio: 448 / 512;
    }
    &:nth-child(5n + 2),
    &:nth-child(5n + 3),
    &:nth-child(5n + 6) {
      grid-column-end: span 2;
      aspect-ratio: 912 / 512;
    }
    & img {
      height: 100%;
      object-fit: cover;
    }
  }
`
export const Content = styled.div`
  ${({ theme }) => theme.textStyles.m375_body}
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  width: 100%;
  max-width: min(${pxToRem(448)}, calc(100% - ${pxToRem(16)} * 2));
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    max-width: max(${pxToRem(448)}, 30vw);
  }
`
export const _RichText = styled(RichText)``
export const _ActionButton = styled(ActionButton)``
